import React from 'react';
import MediaHeroEn from '../components/MediaHeroEn';
import MediaLogosEn from '../components/MediaLogosEn';

function MediaPageEn() {
  return (
    <div className="page">
      <MediaHeroEn />
      <MediaLogosEn />
    </div>
  );
}

export default MediaPageEn;
